
import * as React from 'react';

export const InfoOutline = ({ className, color, size = '20px' }) => /*#__PURE__*/
React.createElement("svg", {

  xmlns: "http://www.w3.org/2000/svg",
  className: className,
  width: size,
  height: size,
  viewBox: "0 0 20 20",
  fill: "none" }, /*#__PURE__*/

React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.53541 10.3918C8.08891 10.5034 7.63646 10.2319 7.52484 9.78545C7.41322 9.33896 7.68468 8.88651 8.13118 8.77489L9.77969 8.36276C9.81813 8.35225 9.85768 8.34443 9.89813 8.3395C10.123 8.31153 10.3428 8.37722 10.5128 8.50981C10.6077 8.58378 10.6871 8.67857 10.7433 8.78953C10.7862 8.87402 10.8152 8.9668 10.8271 9.06484C10.8322 9.10525 10.8342 9.14549 10.8333 9.18531V12.5H11.6666C12.1269 12.5 12.5 12.8731 12.5 13.3333C12.5 13.7936 12.1269 14.1667 11.6666 14.1667H8.33329C7.87305 14.1667 7.49996 13.7936 7.49996 13.3333C7.49996 12.8731 7.87305 12.5 8.33329 12.5H9.16663V10.234L8.53541 10.3918Z",
  fill: color }), /*#__PURE__*/

React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0001 7.78158C9.38443 7.78158 8.88533 7.28248 8.88533 6.66681C8.88533 6.05114 9.38443 5.55205 10.0001 5.55205C10.6158 5.55205 11.1149 6.05114 11.1149 6.66681C11.1149 7.28248 10.6158 7.78158 10.0001 7.78158Z",
  fill: color }), /*#__PURE__*/

React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.99996 1.66667C14.602 1.66667 18.3333 5.39796 18.3333 10C18.3333 14.6021 14.602 18.3333 9.99996 18.3333C5.39791 18.3333 1.66663 14.6021 1.66663 10C1.66663 5.39795 5.39791 1.66667 9.99996 1.66667ZM9.99996 3.33334C6.31838 3.33334 3.33329 6.31843 3.33329 10C3.33329 13.6816 6.31838 16.6667 9.99996 16.6667C13.6815 16.6667 16.6666 13.6816 16.6666 10C16.6666 6.31843 13.6815 3.33334 9.99996 3.33334Z",
  fill: color }));